import React, { useState, useCallback } from "react";

import { ModalWizardStepRenderProps } from "components/ModalWizard/ModalWizard";
import FieldText from "components/FieldText";
import { DataInAnyRow } from "components/PageDashboard/SessionTypesSection/SessionTypesTable/SessionTypesTable";

function StepSessionTitle({
	enableProgressToNextStep,
	disableProgressToNextStep
}: ModalWizardStepRenderProps<DataInAnyRow>) {
	const [currentValue, setCurrentValue] = useState("");

	const handleNewValue = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const sessionTitle = e.currentTarget.value;
			setCurrentValue(sessionTitle);

			const haveValidDescription =
				!!sessionTitle && !/^[\s]+$/.test(sessionTitle);

			if (!haveValidDescription) {
				disableProgressToNextStep({
					alert: {
						title: "One thing missing",
						contents: "Please enter a name for the session."
					}
				});
				return;
			}

			enableProgressToNextStep({
				sessionTitle
			});
		},
		[enableProgressToNextStep, disableProgressToNextStep]
	);

	return <FieldText value={currentValue} onChange={handleNewValue} />;
}

export default StepSessionTitle;
